class CookiesBar extends Component {

    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        super(el);
        el.querySelectorAll('[data-control]').forEach(el => el.addEventListener('click', e => this.cookiesSwitch(e)));
    }


    cookiesSwitch(e) {
        e.preventDefault();
        fetch(e.currentTarget.getAttribute('href') + '&redirect=0').then(r => r.json()).then(r => this.onConsentStored(r)).catch(error => console.error('error:', error));
    }

    onConsentStored(response) {
        if (response.result) {
            this.$el.classList.add('u-hidden');
            EventBus.getInstance().dispatchEvent('cookiesConsentStored', {consent: response.consent});
            window.cookieConsent = response.consent;
        }
    }

}
